import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-stt-inference-save',
  templateUrl: './stt-inference-save.component.html',
  styleUrls: ['./stt-inference-save.component.scss'],
})
export class SttInferenceSaveComponent  implements OnInit {
  @Input() data: any;

  remarks: string = "";

  // constructor(private modalCtrl: ModalController) { }
  constructor(
      private modalCtrl: ModalController,
      private globalService:GlobalService,
      private apiService: ApiService,
    ){}

  ngOnInit() {}

  normalizeText(text: string): string {
    return text?.toLowerCase().replace(/[^\w\s]|_/g, '').replace(/\s+/g, ' ').trim();
  }

  saveRemarks() {
    this.data.remarks = this.remarks; // Trim whitespace from remarks
    try {
      this.globalService.logoutLoading();
      // this.sttInferenceResult(this.data);
      this.apiService.sttInferenceResult(this.data.guid,this.remarks).subscribe(
        async (response) => {
          console.log("Data get successfully:", response);
          this.modalCtrl.dismiss('save');    
          // Add logic to emit or handle saved remarks
          await this.globalService.dismissLoading();
          
        },
        (err) => {
          this.globalService.dismissLoading();
        }
      );
    } catch (error) {
      console.error('Error saving remarks:', error);
      // alert('Failed to save remarks. Please try again.');
    }

    // sttInferenceResult


    
  }

//   retriveSTTTextList() {
//     try {
//       this.apiService.getSTTTextList(lang,this.currentPage,this.pageSize).subscribe(
//         async (response) => {
//           console.log("Data get successfully:", response);
//           this.textListData = response.data; // Assuming the API returns an array of text records
//           this.totalPages = Math.ceil(response.totalCount / Number(this.pageSize)) || 1;
//           await this.globalService.dismissLoading();
          
//         },
//         (err) => {
//           this.totalPages = 1;
//           this.textListData = [];
//           console.error("Error during API call:", err);
//           alert("Failed to save data. Please try again.");
//           this.globalService.dismissLoading();
//         }
//       );

//     } catch (error) {
//       console.error('Unexpected error while data loading:', error);
//       alert('Failed to load data. Please try again.');
//       this.globalService.dismissLoading();
//     }
// }

  closeModal(target:string) {
      this.modalCtrl.dismiss(target);    
    }
  }
